import { render, staticRenderFns } from "./threepart.vue?vue&type=template&id=8bb8ce5a&"
import script from "./threepart.vue?vue&type=script&lang=ts&"
export * from "./threepart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports